export default __webpack_public_path__ + "media/images/home/slide_gw_2026_lg-6985b73aadefd53fa6e503f3d7c8f9d0.png";